import { render, staticRenderFns } from "./model-export.vue?vue&type=template&id=46a0045e&scoped=true"
import script from "./model-export.vue?vue&type=script&lang=ts"
export * from "./model-export.vue?vue&type=script&lang=ts"
import style0 from "./model-export.vue?vue&type=style&index=0&id=46a0045e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a0045e",
  null
  
)

export default component.exports